var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOffersIcon = function SvgOffersIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.02 10.317v6.14a.877.877 0 0 1-.876.876H2.864a.877.877 0 0 1-.876-.877v-6.14zM11.198.669a3.07 3.07 0 0 1 2.774 4.386h2.927c.484 0 .877.392.877.876v2.632a.877.877 0 0 1-.877.877H1.11a.877.877 0 0 1-.877-.877V5.93c0-.484.393-.877.877-.877l2.927.001a3.07 3.07 0 0 1 4.968-3.464A3.05 3.05 0 0 1 11.197.67M6.81 2.423a1.316 1.316 0 0 0-.126 2.625l.126.006h1.316V3.74c0-.684-.522-1.246-1.189-1.31zm4.386 0-.127.006a1.316 1.316 0 0 0-1.183 1.183l-.006.127v1.315h1.316l.126-.006a1.316 1.316 0 0 0 0-2.619z"
  })));
};
export default SvgOffersIcon;